@if (state.showNotification()) {
<div class="toast">
  <div
    class="flex items-center gap-3 bg-black/95 backdrop-blur-xl rounded-2xl px-6 py-4 text-sm animate-slide-up transition-all"
    [ngClass]="state.notificationIsSuccess() ? 'border border-gold/45 shadow-[0_0_30px_rgba(245,183,59,0.25)]' : 'border border-red-500/45 shadow-[0_0_30px_rgba(239,68,68,0.25)]'">
    
    @if (state.notificationIsSuccess()) {
      <span class="text-gold text-lg font-bold">✓</span>
    } @else {
      <span class="text-red-500 text-lg font-bold">✕</span>
    }
    
    <span class="text-white font-medium tracking-wide">{{ state.notificationMessage() }}</span>
    <button (click)="state.showNotification.set(false)"
      class="text-text-dim hover:text-white ml-4 text-xs transition-colors">✕</button>
  </div>
</div>
}
